<template>
  <section>
    <SpectreWrap justify="center">
      <SpectreWrapItem
        v-for="profile in linkedProfiles"
        :key="profile.type"
        class="inline-flex"
      >
        <SpectreTextLink
          as="a"
          :href="profile.href"
          :aria-label="profile.label"
          class="inline-flex"
          @click="profile.href && emit('click', profile.type)"
        >
          <ConnectionIcon
            :type="profile.type"
            class="size-10"
            :variant="iconStyle === 'grayscale' ? 'monochrome' : 'default'"
          />
        </SpectreTextLink>
      </SpectreWrapItem>
    </SpectreWrap>
  </section>
</template>

<script setup lang="ts">
import { SpectreTextLink, SpectreWrap, SpectreWrapItem } from '@agentsoftware/spectre-ui';
import { computed } from 'vue';
import ConnectionIcon from '@/Components/Icons/ConnectionIcon.vue';
import { safeHref } from '@/utils/safeHref';
import SocialProfileData = App.Data.LinkGroup.SocialProfileData;
import IconStyle = App.Enums.LinkGroup.IconStyle;

const props = defineProps<{
  iconStyle: IconStyle;
  profiles: SocialProfileData[];
}>();

const emit = defineEmits<{
  click: [type: SocialProfileData['type']];
}>();

const linkedProfiles = computed(() => props.profiles.map((profile) => ({ ...profile, href: safeHref(profile.fullUrl) })));
</script>
